import { EntitlementsCard } from '@/components/EntitlementsCard';
import { EntitlementsTable } from '@/components/EntitlementsTable';
import { InvoiceHistoryTable } from '@/components/billing/InvoiceHistoryTable';
import { OrgBillingCard } from '@/components/billing/OrgBillingCard';
import { useLanguage } from '@/contexts/LanguageContext';
import { useOrgs } from '@/contexts/OrgsContext';
import { useRoles } from '@/contexts/RolesContext';
import { PageHeader } from '@/components/common/PageHeader';
import { useGetOrganizationProductEntitlements } from '@/api/auth/product-entitlements/product-entitlements';

/**
 * Billing page - displays product entitlements and subscription information
 */
export default function BillingPage() {
  const { t } = useLanguage();
  const { selectedOrganizationId } = useOrgs();
  const { isAdmin, isBillingManager } = useRoles();

  const { data: entitlementsResponse } = useGetOrganizationProductEntitlements(
    selectedOrganizationId ?? '',
    'data-mission',
    undefined,
    {
      query: {
        enabled: !!selectedOrganizationId,
      },
    }
  );

  const hasStripeCustomer = entitlementsResponse?.data.isStripeCustomer ?? false;
  const entitlements = entitlementsResponse?.data.entitlements ?? [];

  return (
    <div className="space-y-6">
      <PageHeader title={t.billing.title} description={t.billing.description} />

      <div className="grid gap-6 md:grid-cols-2">
        <EntitlementsCard className="w-full min-w-0" />
        {(isAdmin || isBillingManager) && <OrgBillingCard hasStripeCustomer={hasStripeCustomer} />}
      </div>

      <EntitlementsTable entitlements={entitlements} hasStripeCustomer={hasStripeCustomer} />

      {(isAdmin || isBillingManager) && hasStripeCustomer && <InvoiceHistoryTable />}
    </div>
  );
}
